var userAgent = require('../internals/engine-user-agent');
var global = require('../internals/global');

module.exports = /iphone|ipod|ipad/i.test(userAgent) && global.Pebble !== undefined;
